import { routeFactory } from "@/RouteFactory";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { BreadCrumbs } from "@stenajs-webui/elements";
import * as React from "react";

interface Props {
  customerId: string;
  breadCrumbName: string;
}

export const ChildCustomersHeader: React.FC<Props> = ({
  customerId,
  breadCrumbName,
}) => {
  return (
    <PageHeader
      title={"List of child customers"}
      breadcrumbs={
        <BreadCrumbs>
          <Crumb
            label={breadCrumbName}
            path={routeFactory.productAndPrice.customer.customer({
              customerId,
            })}
          />
          <Crumb label={"Children"} />
        </BreadCrumbs>
      }
    />
  );
};
